import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ThemeCreatorService {
  private pageSelectedSubject = new Subject<any>();

  pageSelected$ = this.pageSelectedSubject.asObservable();
  private cellSelectedSubject = new Subject<any>();

  cellSelected$ = this.cellSelectedSubject.asObservable();

  constructor() {}

  notifyPageSelected(page: any) {
    this.pageSelectedSubject.next(page);
  }

  notifyCellSelected(cell: any) {
    this.cellSelectedSubject.next(cell);
  }
}
